module.exports = __webpack_public_path__ + "static/media/car-1.4f199713.mp4";